<template>
	<div>
		<!-- h5版 -->
		<div class="feature-wrap-mobile" id="feature">
			<div class="title">{{ title }}</div>
			<div class="feature-con">
				<div class="feature" v-for="(item, index) in featureList" :key="index">
					<img class="img" :src="item.imgSrc">
					<div class="text">{{ item.title }}</div>
					<div class="des">{{ item.des }}</div>
				</div>
			</div>
		</div>
	</div>
  
</template>

<script>
export default {
  props: {
		title: String,
    featureList: Array,
  },
  data() {
    return {}
  },
  methods: {
    changeNav(index) {
      this.navList.forEach(e => {
				e.active = false
			})
			this.navList[index].active = true
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
	.feature-wrap {
		display: none;
	}
 .feature-wrap-mobile {
	 padding: 1.3333rem .7467rem 1.6rem;
	 .title {
		text-align: center;
		font-size: .5867rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: .6933rem;
	 }
		.feature {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			.img {
				margin-top: 1.0667rem;
				width: 1.8667rem;
				height: 1.8667rem;
			}
			.text {
				margin-top: .08rem;
				font-size: .4267rem;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #202640;
				line-height: .5867rem;
			}
			.des {
				margin-top: .4rem;
				font-size: .3733rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #202640;
				line-height: .64rem;
				text-align: left;
			}
		}
 }

</style>
